import BaseCoreApiRequest from "../core-api-requests/baseCoreApiRequest";
import { IPluginSettingTypeCreateDTO, IPluginSettingTypeDTO, IPluginSettingTypeUpdateDTO, UserDefaultDto } from "../coreapi-dto/service/pluginSettingType";
import { ContentType } from "../fetchApiDistributor/contentTypes";
import { IPluginSettingsDTO } from "../ui-api-dto/pluginSettings";
import { UIApiResponse } from "./common";

class UIDefaultPluginSettingsRequest extends BaseCoreApiRequest {
    readonly baseUrl: string
    readonly _token: string
    constructor(baseUrl: string, token: string) {
        super(baseUrl)
        this.baseUrl = baseUrl
        this._token = token
    }

    all(callback: (e: UIApiResponse<IPluginSettingTypeDTO[]>) => void) {
        this.get<IPluginSettingTypeDTO[]>(`${this.baseUrl}/DefaultPluginSettings/all`, [this.getBearerHeader(this._token)], (e) => {
            callback(e)
        });
    }

    getByName(name: string, callback: (e: UIApiResponse<IPluginSettingTypeDTO>) => void) {
        this.get<IPluginSettingTypeDTO>(`${this.baseUrl}/DefaultPluginSettings/GetByName/${name}`, [this.getBearerHeader(this._token)], (e) => {
            callback(e)
        });
    }

    create(model: IPluginSettingTypeCreateDTO, callback?: (e: UIApiResponse<string>) => void) {
          this.post<string>(
            `${this._baseUrl}/DefaultPluginSettings`,model,this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
                (e) => {
                    callback?.(e)
                }
            );
    }

    setUserDefaultProfile(model: UserDefaultDto, callback?: (e: UIApiResponse<boolean>) => void) {
          this.post<boolean>(
            `${this._baseUrl}/DefaultPluginSettings/SetUserDefaultProfile`,model,this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
                (e) => {
                    callback?.(e)
                }
            );
    }

    update(model: IPluginSettingTypeUpdateDTO, callback?: (e: UIApiResponse<null>) => void) {
          this.put(
            `${this._baseUrl}/DefaultPluginSettings`,model,this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson])
            );
    }
}

export default UIDefaultPluginSettingsRequest
